export default "__VITE_ASSET__4B1MywsF__"